export class RedditTracking {
  // Reddit accepts only a set of predefined events, SignUp is one of them
  // For more, see: https://docs.tealium.com/client-side-tags/reddit-pixel-tag/#events
  static track(event: { event: "SignUp"; conversionId?: string }) {
    if (!import.meta.env.PROD) {
      return;
    }

    (window as { rdt?: any }).rdt?.(
      "track",
      event.event,
      event.conversionId ? { conversion_id: event.conversionId } : undefined,
    );
  }
}
